<!--16-临时预约码-->
<template>
  <div>
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome"> 首页 </span>
    </div>
    <div class="cen" v-if="islings">
        <p class="mt40  fz18">
            团队临时下单码
        </p>
        <p class="">
            <!-- <img src="../assets/img/qccode.png" class="cz jndfsyyer"> -->
            <img :src="qrcode" class="cz jndfsyyer2">
        </p>
        <p class=" z9 fz14 mt10">
            预约码截止有效期：{{ tomorrow }}
        </p>
        <p class=" zts fz12 mt5">
            请在此日期前扫码下单，过期作费
        </p>
        
        <div class="mt30 pd">
            <van-button type="primary" class="w100" @click="laimnxer">重新生成</van-button>
        </div>
        <!-- {{this.tempReservationUrl}} -->
    </div>

    <div class="cen" v-else>
        <p class="mt40  fz18">
            团队临时下单码
        </p>
        <p class=" mt20">
            <img src="../assets/img/wulingshima.png" class="cz jndfsyyer ab">
        </p>
        <p class=" z9 fz14 mt10">
            暂时没有团队预约码，请点击按钮生成
        </p>
        <div class="mt30">
            <span class="mr10 fz14">是否生成讲解预约</span><van-switch v-model="explainFlag" size="18px" class="group-order-switch"  active-color="#845F56"/>
        </div>
        <div class="mt10 pd">
            <van-button type="primary" class="w100" @click="laimnxer">开始生成</van-button>
        </div>
    </div>
  </div>
</template>
<script>

import orderService from "@/services/orderService.js";
import QRCode from "qrcode";
import moment from "moment";

export default {
  data() {
    return {
      islings: false, // false 为 无临时预约码
      tempReservationUrl:"",
      qrcode:"",
      tomorrow: "",
      explainFlag: true
    };
  },
  components: {},
  methods: {
      toHome() {
      this.$router.push("/");
    },
    // 开始生成按钮点击触发
    async laimnxer() {
      // this.$toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   forbidClick: true,
      // });
      // setTimeout(() => {
      //   this.islings = true;
      //   this.$toast.clear();
      // }, 3000);
        this.islings = true;
        this.tomorrow =  moment().add(1, "days").format("YYYY-MM-DD HH:mm");
        this.tempReservationUrl = await orderService.getTempReservationUrl(this.tomorrow,this.explainFlag);
        if(this.tempReservationUrl)
        {
             this.qrcode = await this.generateQRCode(this.tempReservationUrl);
              
        }
        
    },
    async generateQRCode(text) {
      try {
        return await QRCode.toDataURL(text, { width: 200 });
      } catch (err) {
        this.$toast(err);
      }
    }
  },
  mounted() {},
  async created() {
     

  },
};
</script>
<style scoped>
.jndfsyyer {
  width: 140px;
  height: 140px;
}
.jndfsyyer2 {
  width: 280px;
  height: 280px;
}

.jndfsyyer.ab {
  width: 112px;
  height: 105px;
}
</style>
